"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyInput = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const input_1 = require("@nbc-design/input");
const input_group_1 = require("@nbc-design/input-group");
const utils_1 = require("./utils");
/** Currency Input is an extended input to use when the user has to enter an amount of money based on the given locale. */
exports.CurrencyInput = React.forwardRef(({ id, name, locale = 'fr', fractionDigits = 2, currency = 'CAD', suffix, value = '', dataTest = 'currency-input', onChange, onBlur, onFocus, onKeyPress, className, hideSymbol = false, length, inputMode = fractionDigits === 0 ? 'numeric' : 'decimal', ...other }, ref) => {
    const [stateValue, setStateValue] = React.useState(value);
    const [isFocus, setIsFocus] = React.useState(false);
    React.useEffect(() => {
        value && setStateValue((0, utils_1.format)(value, locale, fractionDigits, currency, hideSymbol));
    }, [currency, fractionDigits, hideSymbol, locale]);
    React.useEffect(() => {
        !isFocus && setStateValue((0, utils_1.format)(value, locale, fractionDigits, currency, hideSymbol));
    }, [value]);
    const handleChange = (e) => {
        const acceptedCharRegEx = /[^0-9.-.,]+/g;
        const val = e.currentTarget.value;
        if (!acceptedCharRegEx.test(val)) {
            setStateValue(e.currentTarget.value);
        }
        onChange?.(e.currentTarget.value, e);
    };
    const handleOnFocus = (event) => {
        setIsFocus(true);
        const frRegex = /[^0-9.-.,]+/g;
        const enRegex = /[^0-9.-]+/g;
        event.preventDefault();
        const valNumber = event.currentTarget.value.replace(locale === utils_1.LANG.FR || locale === utils_1.LANG.FR_CA ? frRegex : enRegex, '');
        setStateValue(valNumber);
        onFocus?.(event);
    };
    const handleOnBlur = (event) => {
        setIsFocus(false);
        event.preventDefault();
        const floatValue = (0, utils_1.getFloatValue)(event.currentTarget.value, fractionDigits, locale);
        const formattedValue = (0, utils_1.format)(event.currentTarget.value, locale, fractionDigits, currency, hideSymbol);
        setStateValue(formattedValue);
        onBlur?.(event, floatValue, formattedValue);
    };
    const handleKeyPress = (event) => {
        const regEx = /^[0-9.,]+$/;
        !regEx.test(event.key) && event.preventDefault();
        onKeyPress?.(event);
    };
    const classes = (0, classnames_1.default)('dsc-currencyInput', className);
    return suffix ? ((0, jsx_runtime_1.jsx)(input_group_1.InputGroup, { ...other, suffix: suffix, inputId: id, inputName: name, className: classes, dataTest: dataTest || name, ref: ref, value: stateValue, inputMode: inputMode, onChange: handleChange, onFocus: handleOnFocus, onBlur: handleOnBlur, length: length, onKeyPress: handleKeyPress })) : ((0, jsx_runtime_1.jsx)(input_1.Input, { ...other, id: id, name: name, className: classes, dataTest: dataTest || name, ref: ref, value: stateValue, inputMode: inputMode, onChange: handleChange, onFocus: handleOnFocus, onBlur: handleOnBlur, length: length, onKeyPress: handleKeyPress }));
});
exports.CurrencyInput.displayName = 'CurrencyInput';
//# sourceMappingURL=currencyInput.js.map